export const LOCAL_STORAGE_USER_SETTINGS_KEY = 'v2_settings';
export const SESSION_STORAGE_USER_SETTINGS_KEY = 'v2_user_settings';

export const USER_DATA_STORAGE_KEY = 'userData';
